exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs li:not(.current) a[data-v-582fafda]{color:#000}", ""]);

// exports
